var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{class:[
    _vm.activeTabIndex &&
      _vm.contractType === 3 &&
      'page__main_tab_accounting-points' ]},[_c('x-tabs',{attrs:{"titles":_vm.titles,"components":_vm.components,"tab":_vm.activeTabIndex},on:{"update:tab":function($event){_vm.activeTabIndex=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }